import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'formatterDatepicker'
})
export class FormatterDatepickerPipe implements PipeTransform {

  transform(fechaSeleccionada: any): string {
    if (fechaSeleccionada) {
      moment.updateLocale('es', {
        monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_'),
        monthsParseExact: true
    });
      const fecha = moment(`${fechaSeleccionada.year}-${fechaSeleccionada.month}-${fechaSeleccionada.day}`, 'YYYY-MM-DD');
      return fecha.format('MMM DD, YYYY');
    }
    return '';
  }

}
